const NSK_TZ = 'Asia/Novosibirsk';
const HIDE_FROM_NSK = '2026-01-12T00:00:00'; // c этого момента баннер будет скрыт

export const NY_BANNER_HIDE_LS_KEY = 'nyBanner.hideForever';
export const NY_BANNER_SHOWN_SS_KEY = 'nyBanner.shownThisSession';

function nskNowIso(): string {
    const dtf = new Intl.DateTimeFormat('en-CA', {
        timeZone: NSK_TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
    });

    const parts = dtf.formatToParts(new Date());
    const map: Record<string, string> = {};
    for (const p of parts) if (p.type !== 'literal') map[p.type] = p.value;

    return `${map.year}-${map.month}-${map.day}T${map.hour}:${map.minute}:${map.second}`;
}

export function shouldShowNyBannerByTime(): boolean {
    return nskNowIso() < HIDE_FROM_NSK;
}

export function isNyBannerHiddenForever(): boolean {
    try {
        const v = localStorage.getItem(NY_BANNER_HIDE_LS_KEY);
        return v === '1' || v === 'true';
    } catch {
        return false;
    }
}

export function hasNyBannerShownThisSession(): boolean {
    try {
        return sessionStorage.getItem(NY_BANNER_SHOWN_SS_KEY) === '1';
    } catch {
        return false;
    }
}

export function hideNyBannerForever(): void {
    try {
        localStorage.setItem(NY_BANNER_HIDE_LS_KEY, '1');
    } catch {}
}

export function markNyBannerShownThisSession(): void {
    try {
        sessionStorage.setItem(NY_BANNER_SHOWN_SS_KEY, '1');
    } catch {}
}

export function shouldShowNyBanner(): boolean {
    return (
        shouldShowNyBannerByTime() && !isNyBannerHiddenForever() && !hasNyBannerShownThisSession()
    );
}
